import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setAgencyCaseManagementList } from 'src/store/modules/admin'

import {
  AGENCY_CASE_MANAGEMENT_GET_LIST,
  AGENCY_CASE_MANAGEMENT_PATCH_DELETE_ITEM,
  AGENCY_CASE_MANAGEMENT_POST_ITEM,
  AGENCY_CASE_MANAGEMENT_SUCCESS_SAVE_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const fetchAgencyCaseManagementList =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: AGENCY_CASE_MANAGEMENT_GET_LIST,
          query
        }
      })

      dispatch(setAgencyCaseManagementList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchDropdownAgencyCaseManagementList =
  (query = {}) =>
  async (dispatch) => {
    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: AGENCY_CASE_MANAGEMENT_GET_LIST,
          query
        }
      })

      return items
    } catch (err) {
      catchError(err)
    }
  }

export const saveAgencyCaseManagementItem =
  (config = {}) =>
  async () => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: AGENCY_CASE_MANAGEMENT_POST_ITEM
        },
        payload
      })

      showSuccessModal({
        content: AGENCY_CASE_MANAGEMENT_SUCCESS_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateAgencyCaseManagementItem =
  (config = {}) =>
  async () => {
    const { params = {}, payload = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: AGENCY_CASE_MANAGEMENT_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: AGENCY_CASE_MANAGEMENT_SUCCESS_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
